export function increaseDays(date: Date, amount: number): Date {
  return new Date(date.setDate(date.getDate() + amount));
}
